import { API_USER_SWITCH } from '~/constants/routes/api/user-switch/routes.constants'

export const userSwitchRepository = async (data: { identify: string }) => {
  await useCustomFetch(API_USER_SWITCH.path, {
    query: {
      _switch_user: data.identify
    }
  })
}

export const userSwitchLeaveRepository = async () => {
  await useCustomFetch(API_USER_SWITCH.path, {
    query: {
      _switch_user: '_exit'
    }
  })
}
